// Lifecycle values where a pending follow-up can still run.
export const ACTIVE_LIFECYCLE_STATUSES = new Set(['ok', 'pending']);

export const canFollowUpRun = (campaignStatus?: string, lifecycleStatus?: string): boolean => {
  if (campaignStatus === 'canceled') {
    return false;
  }
  if (lifecycleStatus && !ACTIVE_LIFECYCLE_STATUSES.has(lifecycleStatus)) {
    return false;
  }
  return true;
};
